import { render, staticRenderFns } from "./RestShoppingModal.vue?vue&type=template&id=7238ccf0&"
import script from "./RestShoppingModal.vue?vue&type=script&lang=js&"
export * from "./RestShoppingModal.vue?vue&type=script&lang=js&"
import style0 from "./RestShoppingModal.vue?vue&type=style&index=0&id=7238ccf0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports